// extracted by mini-css-extract-plugin
export var alignCenter = "_6l-d";
export var bannerShown = "_6l-6";
export var buttonContent = "_6l-0";
export var cardList = "_6l-1";
export var centerContent = "_6l-2";
export var chevron = "_6l-3";
export var closePanelButton = "_6l-k";
export var conversationContextContainer = "_6l-l";
export var conversationDetailContainer = "_6l-4";
export var detailWrapper = "_6l-7";
export var dropdownButton = "_6l-e";
export var dropdownTitle = "_6l-9";
export var fullHeight = "_6l-5";
export var hidden = "_6l-a";
export var icon = "_6l-b";
export var mergeSuggestionWrapper = "_6l-m";
export var panel = "_6l-i";
export var portalButtonsWrapper = "_6l-c";
export var right = "_6l-j";
export var tableSummaryContainer = "_6l-8";
export var tableSummaryHeader = "_6l-g";
export var threeDotsButton = "_6l-f";
export var wide = "_6l-h";